import {ActionTypes} from './../../cc-imports'

const Actions = {
    addToCache: (key, value)=> {
        return {
            type: ActionTypes.ADD_TO_CACHE,
            payload:{key, value}
        }
    },
    removeFromCache : (key) =>{
        return {
            type:ActionTypes.REMOVE_FROM_CACHE,
            payload:{key}
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/CacheActions.js